import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Header, Table } from '../CommonComponents';
import { Container, Paper } from '../StyledComponents';

import { useDispatch, useSelector } from '../../redux/hooks';
import {
    fetchAllTenantUpdates,
    selectAllTenantUpdates,
    selectFetchingAllTenantUpdates
} from '../../redux/actions/tenantUpdates';
import { TenantUpdateForListType } from '../../types';
import formatTenantUpdateSources from '../../utils/tenantUpdates';

const columns = [{
    name: 'Företag',
    key: 'name',
    canSearch: true
}, {
    name: 'Org. nummer',
    key: 'orgNumber',
    canSearch: true
}, {
    name: 'Ändring',
    key: 'sources',
    getValue: ({ sources }: TenantUpdateForListType) => formatTenantUpdateSources(sources),
    canSearch: true
}, {
    name: 'Uppdaterad av',
    key: 'updatedByName',
    getValue: ({ updatedByName }: TenantUpdateForListType) => updatedByName || '-',
    canSearch: true
}, {
    name: 'Uppdaterades',
    key: 'updatedAt',
    type: 'datetime' as const,
    canFilter: true,
    align: 'right' as const
}, {
    name: 'Hanterat',
    key: 'isHandled',
    type: 'bool' as const,
    canFilter: true
}, {
    name: 'Kontrollerad av',
    key: 'moderatedByName',
    getValue: ({ moderatedByName }: TenantUpdateForListType) => moderatedByName || '-',
    canSearch: true
}, {
    name: 'Kontrollerades',
    key: 'moderatedAt',
    type: 'datetime' as const,
    canFilter: true,
    align: 'right' as const
}];

const TABLE_NAME = 'tenantUpdates';

export default function TenantUpdates() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tenantUpdates = useSelector(selectAllTenantUpdates());
    const isFetching = useSelector(selectFetchingAllTenantUpdates());

    React.useEffect(() => {
        dispatch(fetchAllTenantUpdates());
    }, [dispatch]);

    const onRowClick = React.useCallback((row: TenantUpdateForListType) => {
        navigate(`/tenants/${row.tenantId}`);
    }, [navigate]);

    return (
        <Container>
            <Header title="Nya uppgifter" />

            <Paper padding={0}>
                <Table
                    name={TABLE_NAME}
                    columns={columns}
                    data={tenantUpdates}
                    onRowClick={onRowClick}
                    emptyText={isFetching
                        ? 'Hämtar uppdateringar...'
                        : 'Det finns inga uppdateringar.'}
                    showPagination
                    defaultOrderBy="updatedAt"
                    defaultOrderDirection="desc"
                    defaultFilterValues={{
                        'isHandled-equals': false
                    }}
                />
            </Paper>
        </Container>
    );
}
